import { useMutation, useQueryClient } from '@tanstack/react-query'

import type {
  BookingSessionResponse,
  SubmitPassengersRequest,
} from '../../types/booking-session.js'

import { apiClient } from '../../lib/client.js'
import { syncBookingSessionCache } from './cache.js'
import { bookingSessionKeys } from './keys.js'

export const useSubmitPassengers = (
  sessionId: string,
  /**
   * `throwOnError` accepte aussi un prédicat : l'étape Informations ne renvoie à
   * la boundary d'erreur que les sessions expirées, et rend les autres échecs en
   * ligne pour ne pas perdre le formulaire passagers.
   */
  { throwOnError = false }: { throwOnError?: ((error: Error) => boolean) | boolean }
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: SubmitPassengersRequest) => {
      const response = await apiClient.client.post<BookingSessionResponse>(
        `/booking-session/${sessionId}/passengers`,
        data
      )
      return response.data
    },
    onSuccess: (data) => {
      syncBookingSessionCache(queryClient, data)
      queryClient.setQueryData(bookingSessionKeys.price(sessionId), data)
    },
    throwOnError,
  })
}
